import {Device} from 'expensify-common';

export default Device.getOSAndName;
